// Registro del service worker MINIMO (infra-ops, 21-09-2026 — PUSH A PAU v1.1).
// Ver public/sw.js: solo `push` + `notificationclick`, SIN `fetch` y SIN caches.
//
// Historia: el 18-09 este fichero era `sw-kill.ts` y DESREGISTRABA todo SW al
// arrancar, porque el SW de workbox (precache) servia la oficina vieja tras
// cada deploy. Esa regla sigue viva en dos sitios: aqui se borran las caches
// que queden de aquel SW antes de registrar el nuevo, y el nuevo no crea
// ninguna. Lo unico que cambia es que ahora SI hay un SW registrado — es el
// requisito del Web Push (push.ts necesita `serviceWorker.getRegistration()`).
//
// Idempotente y silencioso: si el navegador no soporta SW (o el registro
// falla), el panel arranca igual y push.ts vera "unsupported"/false.
export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return null;
  try {
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (_e) {
    // Sin permisos o navegador raro: no bloquea el arranque del panel.
  }
  try {
    // `updateViaCache: 'none'` + el no-store del servidor (app.ts /sw.js):
    // cada comprobacion de actualizacion llega al servidor, nunca a una copia.
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' });
    void reg.update().catch(() => undefined);
    return reg;
  } catch (_e) {
    return null;
  }
}
